export const MAIN_CONTAINER = 'main';
export const ALL_PROPS_CONTAINER = 'all-props';
export const CARD_CONTAINER = 'card';
export const LAYOUT_CONTAINER = 'layout-container';
export const DIALOG_CONTENT_CONTAINER = 'dialog-content';
